import { IconBook } from 'featherico';
import PropTypes from 'prop-types';
import LinkButton from '../LinkButton';

export type DocumentationLinkProps = {
    href: string;
};

function DocumentationLink({ href }: DocumentationLinkProps) {
    return (
        <LinkButton openInNewTab={true} href={href}>
            <IconBook /> Documentation
        </LinkButton>
    );
}

DocumentationLink.propTypes = {
    href: PropTypes.string.isRequired,
};

export default DocumentationLink;
